import { Video, Clock, ShieldCheck, MessageCircle } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/Blocks";
import LeadForm from "@/components/site/LeadForm";
import { waLink } from "@/data/site";

const COPY = {
  consulenza: {
    path: "/consulenza-online", eyebrow: "Consulenza online gratuita",
    seoTitle: "Consulenza online gratuita per il tuo sito web | STUDIO WEB NS",
    description: "Prenota una consulenza online gratuita con STUDIO WEB NS: seguiamo clienti in tutta Italia a distanza, in videochiamata, senza impegno.",
    title: "Consulenza online gratuita, ovunque tu sia.",
    intro: "Seguiamo clienti di tutta Italia a distanza. Compila il modulo: ti ricontattiamo per fissare una videochiamata nella fascia oraria che preferisci.",
  },
  preventivo: {
    path: "/preventivo-gratuito", eyebrow: "Preventivo gratuito",
    seoTitle: "Preventivo gratuito sito web, CRM e social | STUDIO WEB NS",
    description: "Richiedi un preventivo gratuito e senza impegno per sito web, catalogo, e-commerce, CRM o gestione social. Risposta entro un giorno lavorativo.",
    title: "Richiedi un preventivo gratuito.",
    intro: "Raccontaci la tua attività e di cosa hai bisogno. Ti inviamo una proposta scritta con costi chiari, IVA esclusa indicata.",
  },
  anteprima: {
    path: "/richiedi-anteprima", eyebrow: "Anteprima personalizzata",
    seoTitle: "Richiedi un’anteprima del sito della tua attività | STUDIO WEB NS",
    description: "Guarda come potrebbe diventare il sito della tua attività: richiedi una proposta grafica personalizzata, senza impegno e soggetta a conferma.",
    title: "Guarda come potrebbe diventare il tuo sito.",
    intro: "Raccontaci la tua attività: valutiamo la richiesta e, se confermata, prepariamo una proposta grafica personalizzata. Non è un sito completo gratuito.",
  },
};

export default function Consultation({ kind }) {
  const c = COPY[kind];
  const crumbs = [{ label: "Home", to: "/" }, { label: c.eyebrow, to: c.path }];
  return (
    <>
      <Seo path={c.path} title={c.seoTitle} description={c.description} jsonLd={crumbsLd(crumbs)} />
      <PageHero crumbs={crumbs} eyebrow={c.eyebrow} title={c.title} intro={c.intro} />
      <section className="py-12 sm:py-16">
        <div className="wrap grid gap-12 lg:grid-cols-[1.4fr_0.8fr]">
          <div className="card p-6 sm:p-10">
            <LeadForm formType={kind} full={kind !== "anteprima"} defaultService={kind === "anteprima" ? "Anteprima personalizzata" : ""} />
          </div>
          <aside className="space-y-6">
            {[[Video, "Videochiamata", "Circa 30 minuti, con lo strumento che preferisci."], [Clock, "Risposta rapida", "Ti ricontattiamo entro un giorno lavorativo per concordare data e ora."], [ShieldCheck, "Nessun impegno", "La consulenza è gratuita. Il preventivo è scritto e senza obbligo."]].map(([I, t, d]) => (
              <div key={t} className="flex gap-4"><I className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" /><div><p className="font-display font-bold">{t}</p><p className="mt-1 text-sm text-slate-600">{d}</p></div></div>
            ))}
            <p className="rounded-xl bg-slate-50 p-4 text-xs leading-relaxed text-slate-600">La data dell’appuntamento viene confermata da noi via email o WhatsApp: al momento non è attiva una prenotazione automatica su calendario.</p>
            <a href={waLink(kind === "preventivo" ? "preventivo" : kind)} target="_blank" rel="noopener noreferrer" data-testid="consult-whatsapp-btn" className="btn-ghost w-full"><MessageCircle className="h-4 w-4" />Preferisci WhatsApp?</a>
          </aside>
        </div>
      </section>
    </>
  );
}
